import { apiResConstants } from '../LineCheckV3/APIResourceConstants';
import { v4 as generateUID } from 'uuid';
import { ApiServiceV2, CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';
import { ServiceOptionsPropConfig } from '../../services/ServiceOptionsPropConfig';
import { APIResourceConstants, SBENDPOINT } from '../../services/api-constants';
import { RecommendedOptionsTranslations } from './types';

export const fetchOptions = async (offerId?: string): Promise<any> => {
  try {
    const endPoint = ServiceOptionsPropConfig?.getInstance()?.getBaseUrl();

    const URL = `${endPoint}/${apiResConstants.SERVICE_OPTIONS_BY_OFFER}${encodeURIComponent(offerId ?? '')}`;
    const options = {
      headers: {
        'x-correlation-id': generateUID(),
        'x-sunrise-channel': apiResConstants?.X_SUN_CHAL
      }
    };
    const optionsData: any = await ApiServiceV2.getApiServiceInstance()
      ?.get(URL, options)
      ?.then((res): any => {
        if (res?.status == 200) {
          return res?.data;
        }
      });

    if (optionsData?.error) {
      return optionsData?.error;
    } else {
      return optionsData;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error--->', error);
    throw error instanceof Error ? error : new Error(String(error));
  }
};

export const fetchStoryblokOptions = async (
  optionCatalogPath: String,
  categories: Array<string>,
  language: string
): Promise<any> => {
  try {
    const sbEndpoint = ServiceOptionsPropConfig?.getInstance()?.getSBUrl();
    const url = `${sbEndpoint}${SBENDPOINT.STORIES_URL}`;
    const optionCategories = categories?.join(',');

    const filterQuery = `filter_query[isSellable][is]=true&filter_query[category][any_in_array]=${optionCategories}&filter_query[component][in]=optionProductBasePage&per_page=100&language=${language}`;

    const params: any = {
      type: 'B2C',
      starts_with: optionCatalogPath ?? '',
      filterQueryParam: filterQuery
    };

    const response = await CMSStoryblokServiceV2.get(url, params);
    const stories = response?.data?.stories ?? [];

    return stories;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error--->', error);
    throw error instanceof Error ? error : new Error(String(error));
  }
};

//function to get translations item by searching by key
export const getTranslation = (
  translations: RecommendedOptionsTranslations,
  key: string
): string => {
  if (Array.isArray(translations)) {
    const found = translations.find(
      (item: { key?: string; label?: string }) =>
        item?.key?.toLocaleLowerCase() === key.toLocaleLowerCase()
    );
    return found?.label ?? '';
  }

  return '';
};

export const updateCartWithServiceOption = async (
  cartId: string,
  payload: any,
  usecase?: string
): Promise<any> => {
  try {
    const apiServiceInstance = ApiServiceV2.getApiServiceInstance();
    if (!apiServiceInstance) {
      throw new Error('Api service instance not available');
    }
    const options: any = apiServiceInstance.getOption ? apiServiceInstance.getOption() : {};
    options.headers = {
      ...(options.headers || {}),
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants?.X_SUN_CHAL
    };
    const cartBaseEndpoint: string = ServiceOptionsPropConfig?.getInstance()?.getCartUrl();

    options.params = {};
    const baseURL = cartBaseEndpoint + APIResourceConstants?.UPDATE_CART + `${cartId}`;
    const URL = usecase
      ? `${baseURL}${baseURL.includes('?') ? '&' : '?'}usecase=${encodeURIComponent(usecase)}`
      : baseURL;
    return apiServiceInstance
      .put(URL, payload, options)
      .then((res: any) => {
        return res?.data;
      })
      .catch((error: any) => {
        if (error.response?.status === 404) {
          return [];
        }
        throw new Error(
          'Promise failed to add/remove recommended service option due to Technical Error!'
        );
      });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error--->', error);
    return error;
  }
};

export const createServiceOptionPayload = (option: any, itemType: string) => {
  const optionEntries = Object.entries(option ?? {}) as Array<[string, number | undefined]>;
  const req = {
    cartItem: [
      {
        itemType,
        items: optionEntries.map(([key, count]) => {
          return { id: key, count: count ? count : 0 };
        })
      }
    ]
  };
  return req;
};
